<template>
    <Container>
        <router-view />
    </Container>
</template>

<script>
import Container from '@/components/site/Container.vue'

export default {
    name: 'DefaultLayout',
    components: {
        Container
    }
}
</script>